import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type StoreConfigQueryVariables = Types.Exact<{
  storeSlug: Types.Scalars['String']['input'];
}>;


export type StoreConfigQuery = { viewer: { __typename: 'Viewer', storefrontConfig: { __typename: 'StorefrontConfig', storeId: string | null, name: string | null, slug: string | null, customAuthDisclaimer: string | null, customFooterDisclaimer: string | null, customAuthPageMarketingCopy: string | null } | null } | null };


export const StoreConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoreConfig_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefrontConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"customAuthDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"customFooterDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"customAuthPageMarketingCopy"}}]}}]}}]}}]} as unknown as DocumentNode;
export type StoreConfigQueryQueryResult = Apollo.QueryResult<StoreConfigQuery, StoreConfigQueryVariables>;

export function useStoreConfigQuery(
  baseOptions: Apollo.QueryHookOptions<StoreConfigQuery, StoreConfigQueryVariables> & ({ variables: StoreConfigQueryVariables; skip?: boolean; } | { skip: boolean; })
) {
  return Apollo.useQuery<StoreConfigQuery, StoreConfigQueryVariables>(
    StoreConfigQueryDocument,
    baseOptions
  );
}

export function useStoreConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreConfigQuery, StoreConfigQueryVariables>) {
  return Apollo.useLazyQuery<StoreConfigQuery, StoreConfigQueryVariables>(
    StoreConfigQueryDocument,
    baseOptions
  );
}

export function useStoreConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StoreConfigQuery, StoreConfigQueryVariables>) {
  return Apollo.useSuspenseQuery<StoreConfigQuery, StoreConfigQueryVariables>(
    StoreConfigQueryDocument,
    baseOptions
  );
}
